import { supportConstants } from '../constants';
import { supportService } from '../services';
import { alertActions, userActions } from './';

export const supportActions = {
  create,
};

function create(supportRequest, props) {
  return dispatch => {
    dispatch(alertActions.info(props.i18n.t('creationInProgress')));
    dispatch(request({ supportRequest }));

    supportService.create(supportRequest).then(
      result => {
        dispatch(success(result));
        dispatch(alertActions.success(props.i18n.t('supportCreationSuccess')));

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 10000);
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userActions.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('supportCreationError')));
        }
      }
    );
  };

  function request(request) {
    return { type: supportConstants.SUPPORT_CREATION_REQUEST, request };
  }
  function success(result) {
    return { type: supportConstants.SUPPORT_CREATION_SUCCESS, result };
  }
  function failure(error) {
    return { type: supportConstants.SUPPORT_CREATION_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/actions/support.actions.js